export const REFERRAL_FORM = () => [
	{
		sections: [
			{
				type: 'input',
				fields: [
					{
						name: 'name',
						key: 'referral.generator.form.name',
						component: 'text',
						required: true,
						validation: /^\S.{1,99}$/,
						isCoralogixMasked:true
					},
					{
						name: 'email',
						key: 'referral.generator.form.email',
						component: 'text',
						required: true,
						validation: /^(([a-zA-Z0-9!#$%&'*+-\/=?^_`{|]{1,64})([@]{1})([a-zA-Z0-9-.]{2,160})([.]{1})([a-zA-Z0-9-.]{2,24}))$/i, // eslint-disable-line
						isCoralogixMasked:true
					}
				]
			}
		]
	},
	{
		sections: [
			{
				type: 'input',
				fields: [
					{
						name: 'linkSent',
						key: 'referral.customer.form.address',
						component: 'linkSent',
						required: false
					}
				]
			}
		]
	}
];
